import Image from "next/image";

function ActiveTagCard({ imageSrc, title, children }) {
  return (
    <div className="flex flex-col items-center text-center max-w-[17.75rem] md:max-w-[15rem] lg:max-w-[17.75rem]">
      <div className="relative w-[17.75rem] h-[17.75rem] md:w-[15rem] md:h-[15rem] lg:w-[17.75rem] lg:h-[17.75rem] mb-[2.25rem] lg:mb-[4.625rem]">
        <Image src={imageSrc} fill alt={title} quality={40} />
      </div>

      <h2 className="text-[2rem] mb-[2rem] h-[4.75rem] font-semibold leading-[38.4px] tracking-[0.32px]">
        {title}
      </h2>
      {children}
    </div>
  );
}

export default ActiveTagCard;
